import { render, staticRenderFns } from "./SoftwareSerialDetailsContainer.vue?vue&type=template&id=602a3f60"
import script from "./SoftwareSerialDetailsContainer.vue?vue&type=script&lang=js"
export * from "./SoftwareSerialDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports